import React from "react";
import Header from "../Protected/Header";
import Footer from "../Protected/Footer";
import StripeInfoUpdateModal from "../../../Components/StripeInfoUpdateModal/StripeInfoUpdateModal";
import { useCurrentUserQuery } from "../../../api/queries/useUserQuery";
import { useCurrentAccountQuery } from "../../../api/queries/useAccountQuery";
import { useFormStates } from "../../../hooks/formStates";
import Account2FaRequiredModal from "../../../Components/Account2FaRequiredModal/Account2FaRequiredModal";

var FULL_VIEW_FOR_URLS = ["/settings/surveys/template/"];

export function ARLayout({ children }) {
  useCurrentUserQuery();
  useCurrentAccountQuery();
  useFormStates.RestoreLocation();

  const isFullView = FULL_VIEW_FOR_URLS.some((url) =>
    window.location.href.includes(url),
  );

  return (
    <div className="main protected">
      {!isFullView && <Header />}
      {children}
      {!isFullView && <Footer />}
      <Account2FaRequiredModal />
      <StripeInfoUpdateModal />
    </div>
  );
}
